var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 102C187.733 102 145.067 136.133 128 204.4C153.6 170.267 183.467 157.467 217.6 166C237.075 170.869 250.995 184.997 266.402 200.637C291.501 226.114 320.551 255.6 384 255.6C452.267 255.6 494.933 221.467 512 153.2C486.4 187.333 456.533 200.133 422.4 191.6C402.925 186.731 389.005 172.603 373.598 156.963C348.499 131.486 319.449 102 256 102ZM128 255.6C59.7333 255.6 17.0667 289.733 0 358C25.6 323.867 55.4667 311.067 89.6 319.6C109.075 324.469 122.995 338.597 138.402 354.237C163.502 379.714 192.551 409.2 256 409.2C324.267 409.2 366.933 375.067 384 306.8C358.4 340.933 328.533 353.733 294.4 345.2C274.925 340.331 261.005 326.203 245.598 310.563C220.498 285.086 191.449 255.6 128 255.6Z",
    fill: "url(#paint0_linear_335_247)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_335_247",
    x1: -14.2222,
    y1: 200.304,
    x2: 427.974,
    y2: 455.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2298BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED7B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.3c925fe9e468b1490c63dc1f30c9d52a.svg";
export { ForwardRef as ReactComponent };